import { isTouchEvent } from './isTouchEvent.js';

const getCoordinateFromEvent = evt => {
  if (isTouchEvent(evt)) {
    return {
      x: evt.touches[0]?.pageX ?? 0,
      y: evt.touches[0]?.pageY ?? 0
    };
  }
  return {
    x: evt.pageX,
    y: evt.pageY
  };
};

export { getCoordinateFromEvent };
//# sourceMappingURL=getCoordinateFromEvent.js.map
